
export enum CorrectionTypeCd {
	ADD_ACC = 'ADD ACC',
	CORR_ACC = 'CORR ACC',
	DEL_ACC = 'DEL ACC'}

